<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center">
    <div class="bg-white w-full rounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <router-link :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3" to="/warehouses">
            <i class="material-icons mx-2">chevron_left</i>
          </router-link>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500 ">New warehouse</div>
          <div v-else class="text-2xl font-bold text-blue-500 ">Edit warehouse</div>
        </div>
      </div>
        <div class="bg-white rounded-lg p-6 pt-2">
          <div class="grid lg:grid-cols-2 gap-6">
              <div class="border border-gray-500  hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                      <label for="country" class="bg-white text-gray-700 px-1">Country</label>
                    </p>
                  </div>
                  <p>
                    <v-select
                      @input="setSelectedContry"
                      v-model="formData.country"
                      :options="options"
                      label="name"
                    >
                      <template slot="option" slot-scope="option">
                        <img
                          class="flag-img"
                          :src="$f.getCountryCode(option.code)"
                        />
                        {{ option.name }}
                      </template>
                    </v-select>
                  </p>
              </div>
              <div class="border border-gray-500  hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                            <label for="name" class="bg-white text-gray-700 px-1">Name <span :class="$colors.required">*</span></label>
                        </p>
                    </div>
                    <p>
                      <input
                      id="name"
                      placeholder="Warehouse name"
                      tabindex="0"
                      type="text"
                      :disabled="formData._id && formData.parent?true:false"
                      v-model="formData.name"
                      class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                    </p>
              </div>
          </div>
   
          <div class="grid lg:grid-cols-2 gap-6 mt-4">
             <div class="border border-gray-500  hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="currency" class="bg-white text-gray-700 px-1">Currency Name <span :class="$colors.required">*</span></label>
                      </p>
                  </div>
                  <p>
                     <input
                      id="currency"
                      placeholder="Warehouse currency name"
                      tabindex="0"
                      type="text"
                      v-model="formData.currency"
                      class="py-2 w-full text-xs px-2 outline-none block"/>
                    </p>
             </div>
             <div class="border border-gray-500  hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="currency" class="bg-white text-gray-700 px-1">Phone code <span :class="$colors.required">*</span></label>
                      </p>
                    </div>
                     <p>
                    <input
                        id="currency"
                        placeholder="212, ...."
                        tabindex="0"
                        type="text"
                        :disabled="!formData.country"
                        v-model="formData.info.phoneCode"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                    </p>
              </div>
            
          </div>
           <div v-if="selectContry" class="grid lg:grid-cols-2 gap-6  mt-4">
                <div class="border border-gray-500  hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="Regroupement" class="bg-white text-gray-700 px-1"> Regroupement</label>
                        </p>
                      </div>    
                      <p>
                        <v-select label="name"  :disabled="formData.parent?true:false" v-model="formData.regroupement" :options="regroupements"></v-select>
                      </p>    
                </div>
                <div class="flex">
              <div class="w-1/2 border hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch relative h-15 bg-white items-center rounded">
                <div class="flex -mr-px justify-center p-1">
                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                    <sup class="uppercase"> MAD </sup><span class="select-none ml-2"> <img  class="flag-img" src="https://static.dwcdn.net/css/flag-icons/flags/4x3/ma.svg"/></span>
                  </span>
                </div>
                <input type="number"  v-model="formData.info.mad" disabled min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
              </div>
              <i class="material-icons mx-2 items-center flex-imp">arrow_forward</i>
             <div class="w-1/2 border hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                <div class="flex -mr-px justify-center p-1">
                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                    <sup class="uppercase"> {{formData.currency}} </sup><span class="select-none ml-2"> <img  class="flag-img" :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/'+selectContry.toLowerCase()+'.svg'"/></span>
                  </span>
                </div>
                <input type="number"  v-model="formData.info.currency" min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
              </div>
              </div>
           </div>  
           <div class="grid lg:grid-cols-2 gap-6 pt-5">
            
              <div class="border border-gray-500  hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="timezone" class="bg-white text-gray-700 px-1">TimeZone <span :class="$colors.required">*</span></label>
                      </p>
                    </div>
                    <p>
                    <v-select :disabled="!formData.country" v-model="formData.info.timezone" :options="timezones">
                 
                </v-select>
                    </p>
              </div>
              <div class="border border-gray-500  hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="parent" class="bg-white text-gray-700 px-1">
                   Parent warehouse</label
                  >
                      </p>
                    </div>
                    <p>
                    <v-select
                     :disabled="(formData._id && formData.is_primary)||!formData.country"
                      @input="setSelectedParent"
                      v-model="formData.parent"
                      :options="warehouses"
                      label="countryName"
                  >
                  <template slot="option" slot-scope="option">
                    <img
                      class="flag-img"
                      :src="option.flag"
                    />
                    {{ option.countryName }}
                  </template>
                </v-select>
                    </p>
              </div>
           
          </div>  
          <div class="grid lg:grid-cols-2 gap-6 mt-4">
             <div class="border border-gray-500  hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="phone" class="bg-white text-gray-700 px-1">Warehouse Phone <span :class="$colors.required">*</span></label>
                      </p>
                  </div>
                  <p>
                     <input
                      id="phone"
                      placeholder="Warehouse phone"
                      tabindex="0"
                      type="text"
                      v-model="formData.phone"
                      class="py-2 w-full text-xs px-2 outline-none block"/>
                    </p>
             </div>
             <div>
                   
              </div>
            
          </div>
           <!-- <div v-if="formData.parent" class="grid lg:grid-cols-2 gap-6 pt-5">
            <div class="border border-gray-500  hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="Regroupement" class="bg-white text-gray-700 px-1"> Zones  <span :class="$colors.required">*</span></label>
                        </p>
                      </div>    
                      <p>
                        <v-select label="name" v-model="formData.zones" :options="zones" multiple></v-select>
                      </p>    
                </div>
            
             <div></div>
          </div>  -->

          <div v-if="formData._id && !formData.parent" class="flex mt-10 mb-5 items-center text-center"><hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <label class="block font-medium font-medium text-base cursor-pointer text-blue-500  w-full" @click="faq_selectedF">
                <div class="bg-indigo-100 mr-4 inline-block text-indigo-400 w-8 h-8 md:w-10 md:h-10 rounded-md  items-center justify-center font-bold text-lg font-display">
                  <span class="align-middle"><i class="large font-bold material-icons align-bottom">settings</i></span>
                </div>
                <span class="font-medium text-base text-blue-700 dark:text-blue-800 align-middle">Call Center settings</span>
            </label>
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
          </div>
          
          <div class="mt-6 pt-3 flex justify-center">
              <button
                @click="save"
                class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-600  hover:shadow-inner hover:bg-blue-700  transition-all duration-300"
              >
                Save
              </button>
            </div>
     
          </div>
      </div>

   <!--Modal callcenter setting -->
    <vue-modal-2 name="ModalSettings" :headerOptions="{title: 'Call Center settings'}" :noFooter="true" modalSize="lg" @onclose="close('')">
        <div class="bg-white rounded-lg">
            <div class="bg-white px-4 pt-0 pb-1 mb-20">
                  <div class="flex flex-wrap items-start border-2 pb-2 p-5 border-dotted rounded-md border-gray-600 mb-2">
                        <div class="w-full border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="currency" class="bg-white text-gray-700 px-1">Traitement des ordres par priorité <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <div class="flex -mr-px justify-center p-1">
                            <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">Status</span>
                          </div>
                          <v-select @input="setSelectedStatus" multiple placeholder="Type orders ..."  v-model="formData.callcenter.callcenter" label="name" :options="params_callcenter" class="callsettings leading-normal w-px flex-1 border-0  border-grey-light rounded rounded-l-none pr-3 self-center relative outline-none"></v-select>
                        </div>
                        <div v-if="formData.callcenter.callcenter.length>1" class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                            <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                            </svg>
                            <span class="sr-only">Info</span>
                            <div>
                              Les commandes sont traitées dans cet ordre: <small><b>{{ formData.callcenter.callcenter.map(e=> e.name).join(' > ') }}</b></small>
                            </div>
                        </div>  
                    </div>

                    <div class="flex flex-wrap items-start border pb-2 p-5 border-dotted rounded-md border-gray-500 mb-2">
                        <div class="w-full border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="currency" class="bg-white text-gray-700 px-1">Pending unreached <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <div class="flex -mr-px justify-center p-1">
                            <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">Minutes</span>
                          </div>
                          <input type="number"   v-model="formData.callcenter.pending_unreached.timeMinutes" min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                        </div>
                        <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                            <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                            </svg>
                            <span class="sr-only">Info</span>
                            <div>
                              Combien de temps la commande sera-t-elle à nouveau traitée ?
                            </div>
                        </div>  
                        <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                            <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                            </svg>
                            <span class="sr-only">Info</span>
                            <div>
                              Mettez le chiffre <b>0</b> si vous ne souhaitez pas appliquer cette fonctionnalité
                            </div>
                        </div>  
                    </div>
                    <div class="flex flex-wrap items-start border pb-2 p-5 border-dotted rounded-md border-gray-500 mb-2">
                        <div class="w-full border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="currency" class="bg-white text-gray-700 px-1">Unreached <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <div class="w-full p-2 mt-3">
                            <div class="border w-full border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch relative h-15 bg-white items-center rounded">
                                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                      <label for="currency" class="bg-white text-gray-700 px-1">Traitement par date <span :class="$colors.required">*</span></label>
                                    </p>
                                  </div>
                                  <div class="flex -mr-px justify-center p-1">
                                    <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                                      Jours (-)
                                    </span>
                                  </div>
                                  <input type="number"  v-model="formData.callcenter.unreached.nbDateDays"  min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                            </div>
                            <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                            <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                            </svg>
                            <span class="sr-only">Info</span>
                            <div>
                              les orders <b>unrached</b> sera traitée depuis ({{ $moment().startOf('week').subtract(formData.callcenter.unreached.nbDateDays, 'days').format('YYYY-MM-DD') }})
                            </div>
                        </div>  
                        <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                            <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                            </svg>
                            <span class="sr-only">Info</span>
                            <div>
                              Mettez le chiffre <b>0</b> si vous ne souhaitez pas appliquer la date
                            </div>
                        </div>  
                          </div>
                          <div class="grid lg:grid-cols-2 gap-6 pt-5 w-full p-2">
                              <div class="border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch relative h-15 bg-white items-center rounded">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                   <p>
                                    <label for="currency" class="bg-white text-gray-700 px-1">Nombre d'appels <span :class="$colors.required">*</span></label>
                                   </p>
                                </div>
                                <div class="flex -mr-px justify-center p-1">
                                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                                    Appels
                                  </span>
                                </div>
                                <input type="number"  v-model="formData.callcenter.unreached.nbCalls"  min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                              </div>
                             
                            <div class="border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                   <p>
                                    <label for="currency" class="bg-white text-gray-700 px-1">Ou Nombre des jours <span :class="$colors.required">*</span></label>
                                   </p>
                                </div>
                                <div class="flex -mr-px justify-center p-1">
                                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                                    Jours (-)
                                  </span>
                                </div>
                                <input type="number"  v-model="formData.callcenter.unreached.timeDays" min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                              </div>
                          </div>
                           <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                              <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                              </svg>
                              <span class="sr-only">Info</span>
                              <div>
                                Nombre d'appels a quelle order sera <b>Unrached</b>.
                              </div>
                          </div> 
                            <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                              <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                              </svg>
                              <span class="sr-only">Info</span>
                              <div>
                                Ou la commande si le nombre d'appels n'est pas réalisé dans un délai à compter de la date de création de la commande.
                              </div>
                          </div> 
                          <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                            <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                            </svg>
                            <span class="sr-only">Info</span>
                            <div>
                              Mettez le chiffre <b>0</b> si vous ne souhaitez pas appliquer la date
                            </div>
                        </div>  
                        </div>
                        
                    </div>
                    <div class="flex flex-wrap items-start border pb-2 p-5 border-dotted rounded-md border-gray-500 mb-2">
                        <div class="w-full border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="currency" class="bg-white text-gray-700 px-1">Expired <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <div class="grid lg:grid-cols-2 gap-6 pt-5 w-full p-2">
                              <div class="border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch relative h-15 bg-white items-center rounded">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                   <p>
                                    <label for="currency" class="bg-white text-gray-700 px-1">Nombre d'appels <span :class="$colors.required">*</span></label>
                                   </p>
                                </div>
                                <div class="flex -mr-px justify-center p-1">
                                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                                    Appels
                                  </span>
                                </div>
                                <input type="number"  v-model="formData.callcenter.expired.nbCalls"  min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                              </div>
                             
                            <div class="border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                   <p>
                                    <label for="currency" class="bg-white text-gray-700 px-1">Ou Nombre des jours <span :class="$colors.required">*</span></label>
                                   </p>
                                </div>
                                <div class="flex -mr-px justify-center p-1">
                                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                                    Jours (-)
                                  </span>
                                </div>
                                <input type="number"  v-model="formData.callcenter.expired.timeDays" min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                              </div>
                          </div>
                           <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                              <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                              </svg>
                              <span class="sr-only">Info</span>
                              <div>
                                Nombre d'appels a quelle order sera <b>Expired</b>.
                              </div>
                          </div> 
                            <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                              <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                              </svg>
                              <span class="sr-only">Info</span>
                              <div>
                                Ou la commande si le nombre d'appels n'est pas réalisé dans un délai à compter de la date de création de la commande.
                              </div>
                          </div> 
                          <div class="flex w-full items-center p-2 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
                            <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path>
                            </svg>
                            <span class="sr-only">Info</span>
                            <div>
                              Mettez le chiffre <b>0</b> si vous ne souhaitez pas appliquer la date
                            </div>
                        </div>  
                        </div>
                        
                    </div>
               
            </div>    
            <div class="modal-footer px-5 border0-t text-right">
                    <a href="#" @click="close('')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</a>
                    <a href="#" @click="save" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-green-600 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative">Save</a>
                </div>
        </div>
    </vue-modal-2>     

      <!-- Modal CONFIRM LIVREUR STATUS-->
      <vue-modal-2 name="modalConfirm" :headerOptions="{title: `Confirm Status date par priorité: ${params_callcenter_selected.status}`}" :noFooter="true" modalSize="md">
                <div class="flex flex-col w-full h-auto">
                <!-- Header -->
                <div class="bg-white rounded px-2  pb-2 flex flex-col">
                    <p class="font-bold text-center">Veuillez sélectionner propriétés par Date  📣</p>
                    <div class="p-5 pb-2">
                        <div class="border border-gray-700 animation-pulse   w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                <p>
                                    <v-select   placeholder="Sort by date ..."  v-model="sortData" label="name" :options="sort_callcenter" ></v-select>
                                </p>
                         </div>
                    </div>
                    
                    <div class="flex p-2 mt-4">
                        <div class="flex-auto flex flex-row-reverse"> 
                            <button  @click="ConfirmStatus" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm </button>
                            <!-- <button :disabled="loading"  @click="CloseModal('modalConfirm')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none"> Annuler</button> -->
                        </div>
                    </div>
                </div>
               </div>
            </vue-modal-2>
         <!-- End Modal CONFIRM LIVREUR STATUS -->

  </div>
</template>

<script>
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {
        name: "",
        phone:null,
        regroupement:null,
        callcenter:{pending_unreached:{},unreached:{},expired:{},callcenter:[]},
       // zones:[],
        info:{
          mad:1,
          currency:1,
          timezone:null
        }
      },
      options: this.$countries,
      optionsTimezones: this.$countriestimezones,
      regroupements:[],
      selectContry:"",
      zones:[],
      selectContryParent:null,
      timezones:[],
      warehouses:[],
      faq_selected:false,
      params_callcenter:[{name:'Pending fresh',sort:"-1",key:'pending fresh'},{name:'A rappeler',sort:"-1",key:'pending remind'},{name:'Pending unreached',sort:"-1",key:'pending unreached'}],
      sort_callcenter:[{name:"Nouvelle date",sort:"-1"},{name:"Ancienne date",sort:"1"}],
      sortData:{name:"Nouvelle date",sort:"-1"},
      params_callcenter_selected:{index:0,status:""}
    };
  },
  async mounted() {
   // await this.getUser();
    await this.getRegroupements();
    this.dataToEdit();
  },
  methods: {
    setSelectedStatus(status){
       if(status && status.length>0){
        console.log('id----------',status)
        console.log('callcenter----------',this.formData.callcenter.callcenter)

          this.params_callcenter_selected.index=this.formData.callcenter.callcenter.length-1;

          if(this.formData.callcenter.callcenter.length !== 0){
            //set same name in same element selected
            this.formData.callcenter.callcenter.forEach(elem => {
              if(elem.key === status[status.length-1].key){
                elem.name= this.formData.callcenter.callcenter.filter(item=> item.key === status[status.length-1].key)[0].name;
              }
            });
           
            //check duplicated element by key selected
            const ids = this.formData.callcenter.callcenter.map(({ key }) => key);
            const filtered = this.formData.callcenter.callcenter.filter(({ key }, index) => !ids.includes(key, index + 1));
            this.formData.callcenter.callcenter=filtered;

            if(this.formData.callcenter.callcenter.length === status.length){
              this.params_callcenter_selected.status=this.formData.callcenter.callcenter[this.formData.callcenter.callcenter.length-1].name;
              this.$vm2.open('modalConfirm');
            }else return false
            
          }   
       }else this.formData.callcenter.callcenter=[];
    },
    ConfirmStatus(){
      console.log('sort data----',this.sortData)
      let dataSelected= this.formData.callcenter.callcenter[this.params_callcenter_selected.index];
      dataSelected.sort=this.sortData.sort;
      //remove entre parantaise ()
      dataSelected.name=dataSelected.name.replace(/["'(].*["')]/, '');
      dataSelected.name=dataSelected.name+'('+this.sortData.name+')';
      this.$vm2.close('modalConfirm');
    },
    faq_selectedF(){
       this.$vm2.open('ModalSettings');
    },
    close(){
       this.$vm2.close('ModalSettings');
    },
    async getRegroupements(){
        const res = await this.$server.search("regroupements",{limit:1000});
        if (res && res.content.results) this.regroupements = res.content.results;
        else this.regroupements = [];
    }, 
    async setSelectedParent(contry) {
      this.formData.regroupement=null;
       if(contry){
         this.formData.parent=contry;
         this.selectContryParent=contry.code;
        // await this.getZones({warehouse:contry._id});
       }else {
         this.formData.parent=null;
       }
    },
    setSelectedContry(contry){
      this.warehouses = this.currentUser.warehouses;
      console.log('warehouses 11-------',this.warehouses)
      if(contry){
        this.warehouses=this.warehouses.filter(warehouse => warehouse.country == contry.code);
        console.log('warehouses 22-------',this.warehouses)
        this.formData.info.timezone=this.formData.info.phoneCode=this.formData.currency=null;
        this.timezones=[];
        this.formData.country=contry.name;
        this.formData.countryName=contry.name;
        this.selectContry=contry.code;
        const dataCountry=this.$f.getTimezonesByCode(this.optionsTimezones,contry.code);
        this.optionsTimezones.forEach(x => {x.timezones.forEach(y => {  this.timezones.push(y.name);});});
       // console.log('timezones-----',this.timezones);
        this.formData.currency=dataCountry.currency.code;
      }else this.warehouses=[];
    },
    setSelectedTimezone(timezone){
      console.log('timezone------',timezone)
      //if(timezone) this.formData.info.timezone=timezone;
      console.log('tim-----',this.formData.info)
    },
    async getZones(filters) {
      filters['limit']=1000;
      console.log('filters--------',filters)
     const zones = await this.$server.search("zones", filters);
     console.log('zones--------',zones)
     if(zones && zones.content){
       this.zones=zones.content.results;
     }else this.zones=[];
    },
    async save() {
      if (this.formData._id) {
         this.formData.country=this.selectContry;
         this.formData.flag = this.$f.getCountryCode(this.selectContry);
          if (this.checkData()) {
            console.log('formData', this.formData)
            const data = await this.$server.update("warehouses", this.formData);
            this.formData.country=this.$f.getCountryNameByCode(this.options,this.selectContry);
            if (data && data._id) {
              console.log('dtat_________',data)
              alert("warehouse updated", "success");
            }else alert(data ,"warning");
          }else alert("required field", "warning");
        
      }else {
          if(this.checkData()) {
              this.formData.country=this.selectContry;
              // const resW = await this.$server.get("warehouses", { country: this.selectContry,}); 
           
              //  if(resW.content != "warehouses not found"){
              //     this.formData.country=this.$f.getCountryNameByCode(this.options,this.selectContry);
              //     alert("warehouse already exist in this contry", "warning");
              //      return false
              //  }
              this.formData.flag = this.$f.getCountryCode(this.selectContry) 
              const data = await this.$server.create("warehouses", this.formData);
              this.formData.country=this.$f.getCountryNameByCode(this.options,this.selectContry);
              console.log('data---------',data)
              if (data && data._id){
                alert("warehouse created", "success");
                this.formData.name= this.formData.country =this.selectContry= "";
               // this.formData.zones=[];
              }else alert(data ,"warning");
        }else {
          alert('required field', "warning");
          // if(this.formData.parent){
          //     if(this.formData.zones.length===0){
          //       alert("Zones required !!", "warning");
          //       return false;
          //     }
          //  }
        };
      }
    },
    emtyTabId(){
      let columns = document.querySelectorAll('.form-checkbox');
      columns.forEach(column => {column.checked = false});
      delete formData.zone;
    },
     async getRowDetail(id) {
        // let rows = this.selectedRows;
        //console.log('.rowCheckboxZone-'+id)
        let columns = document.querySelectorAll('.form-checkbox');
        let element = document.querySelector('.rowCheckboxZone-'+id);
        columns.forEach(column => {column.checked = false});
        element.checked = true;
        this.formData.zone=id;
       // console.log('formdate______________',this.formData)
     
    },
    checkData() {
      if (
        this.formData.name &&
        this.formData.country &&
        this.formData.info &&
        this.formData.info.timezone  &&
        this.formData.info.phoneCode 
      ) {
        // if(this.formData.parent){
        //   if(this.formData.zones.length===0){
        //      alert("Zones required !!", "warning");
        //      return false;
        //   }
        // }
        return true;
      } else {
        console.log(' this.formData-----', this.formData)
        return false;
      }
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
      //console.log(this.currentUser);
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("warehouses", {
          id: this.$route.params.id,
          all:true
        });
        this.formData = editData.content;
        this.selectContry=this.formData.country;
        console.log('this.formData------',this.formData)
        this.formData.country=this.$f.getCountryNameByCode(this.options,this.formData.country);
        this.optionsTimezones.forEach(x => {x.timezones.forEach(y => {  this.timezones.push(y.name);});});
        if(this.formData.parent){
          this.warehouses = this.currentUser.warehouses;
          this.warehouses=this.warehouses.filter(warehouse => warehouse.country == this.selectContry);
        //  await this.getZones({warehouse:this.formData.parent._id});
        } 
        if(!this.formData.callcenter) this.formData.callcenter={pending_unreached:{},unreached:{},expired:{},callcenter:[]};
        if(!this.formData.callcenter.callcenter) this.formData.callcenter.callcenter=[]
        //console.log(' this.formData------',this.formData);
        //console.log(' this.timezones------',this.timezones);
      }
    },
    /*************************************************************** */
    /**************************************************************/
  },
};
</script>

<style scoped>

hr {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 0;
  border-left: none;
  border-bottom: 2px solid #3182ce;
}
.form-checkbox:checked {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
    border-color: transparent;
    background-color: currentColor;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
}
.items {
    display: flex;
    flex-direction: column;
    padding: 10px;
    counter-reset: done-items undone-items;
}
.flex-imp{
   display: flex !important;
}
/* .items input {
    display: block;
    height: 53px;
    margin: 0 0 -53px -9999px;
    outline: none;
    counter-increment: done-items;
} */
.items input:checked + label {
    -webkit-animation: done .5s;
    animation: done .5s;
}
.items label{
  position: relative;
  display: block;
  position: relative;
  padding: 15px 0 15px 15px;
  border-top: 1px dashed #e2e8f0;
  cursor: pointer;
  -webkit-animation: undone .5s;
  animation: undone .5s;
}
.items label:first-child{
  border-top:inherit
}
.items label i {
    display: block;
    position: absolute;
    top: 11px;
    left: 10px;
}
.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}
.tag_cities {
  width: 100%;
  max-width: 100%;
}
.vs__dropdown-toggle {
  border: none;
}
.tag_cities .tag {
  background: rgb(49 130 206 / 16%);
  border-radius: 20px;
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2px;
  margin-bottom: 5px;
  min-height: 28px;
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.7);
  position: relative;
  padding-right: 0;
}
.vs-chip--text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: 10px;
}
.vs-chip--close {
  width: 20px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
}
.tag_cities .tag [data-role="remove"]::after {
  content: "x";
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}
.tag_cities .tag [data-role="remove"] {
  margin-left: 8px;
  cursor: pointer;
}
.top-100 {
  top: 100%;
}

.bottom-100 {
  bottom: 100%;
}

.max-h-select {
  max-height: 300px;
}
</style>